/**
 * APIL Url: ADAC.Internet.Types.Person.MglArt
 * MglArt, Werte: NMG = 0; BAS = 1; PLU = 2; PAR = 3; KIN = 4; JUV = 5; A0 = 6; A1 = 7; A2 = 8; A4 = 9; A5 = 10; A8 = 11; A9 = 12; B2 = 13; B3 = 14; B4 = 15; B5 = 16; B5A = 17; B6 = 18; B8 = 19; B9 = 20; C1 = 21; C2 = 22; E1 = 23; E2 = 24; EC1 = 25; EC2 = 26; EC3 = 27; EC4 = 28; EN1 = 29; EN2 = 30; EN3 = 31; EN4 = 32; F0 = 33; F1 = 34; F2 = 35; FJ1 = 36; J3 = 37; K1 = 38; N1 = 39; N11 = 40; N2 = 41; R1 = 42; R2 = 43; RM1 = 44; T1B = 45; T1R = 46; E17 = 47; J1 = 48; J2 = 49; N17 = 50; PA1 = 51; PC1 = 52; A0P = 53; A1P = 54; A2P = 55; A5P = 56; A8P = 57; A9P = 58; B2P = 59; B3P = 60; B4P = 61; B5P = 62; B6P = 63; B8P = 64; B9P = 65; C1P = 66; C2P = 67; N1P = 68; N2P = 69; F0U = 70; F1U = 71; F2U = 72; PRE = 73; PLA = 74; PPA = 75; ONL = 76; 
 */
export enum MglArtApi {
	NMG = 0,  // NMG
	BAS = 1,  // BAS
	PLU = 2,  // PLU
	PAR = 3,  // PAR
	KIN = 4,  // KIN
	JUV = 5,  // JUV
	A0 = 6,  // A0
	A1 = 7,  // A1
	A2 = 8,  // A2
	A4 = 9,  // A4
	A5 = 10,  // A5
	A8 = 11,  // A8
	A9 = 12,  // A9
	B2 = 13,  // B2
	B3 = 14,  // B3
	B4 = 15,  // B4
	B5 = 16,  // B5
	B5A = 17,  // B5A
	B6 = 18,  // B6
	B8 = 19,  // B8
	B9 = 20,  // B9
	C1 = 21,  // C1
	C2 = 22,  // C2
	E1 = 23,  // E1
	E2 = 24,  // E2
	EC1 = 25,  // EC1
	EC2 = 26,  // EC2
	EC3 = 27,  // EC3
	EC4 = 28,  // EC4
	EN1 = 29,  // EN1
	EN2 = 30,  // EN2
	EN3 = 31,  // EN3
	EN4 = 32,  // EN4
	F0 = 33,  // F0
	F1 = 34,  // F1
	F2 = 35,  // F2
	FJ1 = 36,  // FJ1
	J3 = 37,  // J3
	K1 = 38,  // K1
	N1 = 39,  // N1
	N11 = 40,  // N11
	N2 = 41,  // N2
	R1 = 42,  // R1
	R2 = 43,  // R2
	RM1 = 44,  // RM1
	T1B = 45,  // T1B
	T1R = 46,  // T1R
	E17 = 47,  // E17
	J1 = 48,  // J1
	J2 = 49,  // J2
	N17 = 50,  // N17
	PA1 = 51,  // PA1
	PC1 = 52,  // PC1
	A0P = 53,  // A0P
	A1P = 54,  // A1P
	A2P = 55,  // A2P
	A5P = 56,  // A5P
	A8P = 57,  // A8P
	A9P = 58,  // A9P
	B2P = 59,  // B2P
	B3P = 60,  // B3P
	B4P = 61,  // B4P
	B5P = 62,  // B5P
	B6P = 63,  // B6P
	B8P = 64,  // B8P
	B9P = 65,  // B9P
	C1P = 66,  // C1P
	C2P = 67,  // C2P
	N1P = 68,  // N1P
	N2P = 69,  // N2P
	F0U = 70,  // F0U
	F1U = 71,  // F1U
	F2U = 72,  // F2U
	PRE = 73,  // PRE
	PLA = 74,  // PLA
	PPA = 75,  // PPA
	ONL = 76  // ONL
};